import React from "react";
import styled from "styled-components";
import { Button } from "melodies-source/Button";
import { Body1, H1, H2 } from "melodies-source/Text";
import { ReactComponent as CheckIcon } from "assets/svg/check-circle-green.svg";
import { Card } from "melodies-source/Card";
import { StepProps } from "..";
import { useHistory } from "react-router-dom";
import { doc, getFirestore, setDoc } from "firebase/firestore";
import { useUser } from "auth";

export const AccountCreated: React.FC<StepProps> = () => {
  const { user } = useUser();
  const history = useHistory();

  const handleDone = async () => {
    try {
      await setDoc(
        doc(getFirestore(), `profiles/${user.uid}`),
        {
          shouldOnboard: false,
        },
        {
          merge: true,
        },
      );
      history.push("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <StyledCard isElevated>
      <Container>
        <CheckIcon />
        <H1>Account Created</H1>
        <Body1>
          You successfully signed up, and we’ve verified your account.
        </Body1>
        <DashboardButton onClick={handleDone}>
          Go to your dashboard
        </DashboardButton>
      </Container>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  width: min(500px, 90vw);

  a {
    color: var(--main-color);
  }

  svg {
    width: 60px;
  }

  ${Body1} {
    margin: 10px 0 5px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 20px 40px 40px;

  ${Body1} {
    text-align: center;
  }
`;

const DashboardButton = styled(Button)`
  margin: 30px 0 5px 0;

  ${({ theme }) => theme.media.mobile} {
    margin-top: 20px;
  }
`;
